import { apiFetch } from "../../lib/utils"; // Import apiFetch for API calls

const SendingEndPoint = "/Sendings"; // Define the endpoint for the reviews API

// Function to fetch all sendings
const GetAllSendings = async (): Promise<any[]> => {
    try {
        const response = await apiFetch(`${SendingEndPoint}/api/allsendings`);
        const sendingData = await response.json();

        console.log("Fetched sending data:", sendingData);  // Log the incoming data

        return sendingData.map((sending: any) => ({
            ...sending,
            supplierName: sending.supplierName  // Include the supplier name from the response
        }));
    } catch (error) {
        console.error("Failed to fetch sendings:", error);
        return [];
    }
};

// Function to fetch sendings by reviewId
const GetSendingsByReviewId = async (reviewId: number): Promise<any[]> => {
    try {
        const response = await apiFetch(`${SendingEndPoint}/api/sendings/${reviewId}`); // Call API with reviewId
        const sendingData = await response.json();
        // console.log("Fetched sendings by reviewId:", sendingData); // Log the sending data
        return sendingData;
    } catch (error) {
        console.error("Failed to fetch sendings by reviewId:", error);
        return [];
    }
};

const getSendingDetails = async (sendingId: number) => {
    try {
        const response = await apiFetch(`${SendingEndPoint}/api/sendings/details/${sendingId}`, "GET");

        if (!response.ok) {
            throw new Error(`Failed to fetch sending details: ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error fetching sending details:', error);
        throw error;
    }
};

// Function to update the IsHandled status of a sending
const UpdateSendingHandledStatus = async (sendingId: number, isHandled: boolean): Promise<void> => {
    try {
        const response = await apiFetch(
            `${SendingEndPoint}/api/sendings/${sendingId}/updateIsHandled`,
            "PUT",
            JSON.stringify(isHandled),  // Send the boolean directly as JSON
            { "Content-Type": "application/json" }
        );

        if (!response.ok) {
            throw new Error(`Failed to update handled status: ${response.statusText}`);
        }

        console.log(`Successfully updated IsHandled status to ${isHandled} for sending ID ${sendingId}`);
    } catch (error) {
        console.error("Failed to update handled status:", error);
        throw error;
    }
};

const UpdateSendingHandledStatusBulk = async (sendingIds: number[], isHandled: boolean): Promise<void> => {
    try {
        const response = await apiFetch(
            `${SendingEndPoint}/api/sendings/updateIsHandledBulk`,
            "PUT",
            JSON.stringify({ sendingIds, isHandled }),
            { "Content-Type": "application/json" }
        );

        if (!response.ok) {
            throw new Error(`Failed to update handled status: ${response.statusText}`);
        }

        console.log(`Successfully updated IsHandled status for sending IDs: ${sendingIds.join(", ")}`);
    } catch (error) {
        console.error("Failed to update handled status:", error);
        throw error;
    }
};

// const UpdateReviewHandledStatus = async (reviewId: number, isHandled: boolean): Promise<void> => {
//   const response = await apiFetch(
//     `${SendingEndPoint}/api/reviews/${reviewId}/updateIsHandled`,
//     "PUT",
//     JSON.stringify(isHandled),
//     { "Content-Type": "application/json" }
//   );

//   if (!response.ok) {
//     throw new Error(`Failed to update review handled status: ${response.statusText}`);
//   }
// };
const UpdateReviewHandledStatus = async (
  reviewId: number,
  isHandled: boolean,
  comment?: string
): Promise<void> => {
  const body = {
    isHandled,
    comment: comment ?? null,
  };

  const response = await apiFetch(
    `${SendingEndPoint}/api/reviews/${reviewId}/updateIsHandled`,
    "PUT",
    JSON.stringify(body),
    { "Content-Type": "application/json" }
  );

  if (!response.ok) {
    // valfritt: läs text för bättre fel från backend
    const msg = await response.text().catch(() => response.statusText);
    throw new Error(msg || `Failed to update review handled status`);
  }
};

// Export the API functions
export {
    GetAllSendings,
    GetSendingsByReviewId,
    getSendingDetails,
    UpdateSendingHandledStatus,
    UpdateSendingHandledStatusBulk,
    UpdateReviewHandledStatus
};
